import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // ✅ Only reset scroll when user navigates via Link / push
    if (navigationType === "PUSH") {
      window.scrollTo(0, 0);
    }
    // ✅ Do nothing on POP (Back/Forward buttons)
  }, [pathname, navigationType]);

  return null;
}
